import * as moment from "moment";
import {InvoiceEventApiDto, InvoicePaidEventDataApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import InvoiceEvent, {InvoiceEventTypeEnum} from "./InvoiceEvent";

/**
 * Invoice paid event model.
 */
export default class InvoicePaidEvent extends InvoiceEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {InvoiceEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} creator entity which created the event.
	 * @param {moment.Moment} creationDateTime creation date of event.
	 * @param {InvoicePaidEventData} data invoice paid event data.
	 */
	constructor(public readonly id: string,
		public readonly type: InvoiceEventTypeEnum,
		public readonly creator: AuthenticatedEntity,
		public readonly creationDateTime: moment.Moment,
		public readonly data: InvoicePaidEventData) {
		super(id, type, creator, creationDateTime);
	}

	public static fromJson(json: InvoiceEventApiDto): InvoicePaidEvent {
		const data = InvoicePaidEventData.fromJson(json.data as InvoicePaidEventDataApiDto);
		const creator = AuthenticatedEntity.fromJson(json.creator);
		return new InvoicePaidEvent(json.id, InvoiceEventTypeEnum.InvoicePaid, creator,
			moment(json.creationDateTime), data);
	}

	getIcon() {
		return Icon.Finance;
	}

	getActivityType(): string {
		return `INVOICE PAID`;
	}

	getActivityMessage(): string {
		return `Invoice has been paid`
	}
}

export class InvoicePaidEventData {
	constructor(public readonly customerId: string,
		public readonly invoiceNo: string,
		public readonly referenceNumber: string) {}

	public static fromJson(json: InvoicePaidEventDataApiDto): InvoicePaidEventData {
		return new InvoicePaidEventData(json.customerId, json.invoiceNo, json.referenceNumber);
	}
}
